<template>
  <div>
    <campaign-list :addCategoryBtnShow="true" :tableColumns="tableColumns" :params="params" :addBtnShow="addBtnControl" :multiBtnShow="true" />
  </div>
</template>

<script>
import CampaignList from '../campaign/Links.vue';

export default {
  name: 'EmailList',
  components: {
    CampaignList,
  },
  data() {
    return {
      isAddNewGroupModalActive: false,
      editingGroup: null,
      tableColumns: [
        { key: 'id', sortable: true },
        { key: 'campaign_name', label: 'Paylaşım', sortable: true },
        { key: 'description', label: 'Açıklama', sortable: false },
        { key: 'event_count', label: 'Ziyaret', sortable: false },
        { key: 'cart_count', label: 'Sepete Ekleme', sortable: false },
        { key: 'order_count', label: 'Sipariş Adedi', sortable: false },
        { key: 'total_amount', label: 'Sipariş Tutarı', sortable: false },
        { key: 'status', label: 'Durum' },
        { key: 'actions', label: 'Detay' },
      ],
      params: {
        filter: {
          type: 5, // Email için type 5
        },
        multiLinks: true,
        source: 'list',
      },
    };
  },
  computed: {
    addBtnControl() {
      return this.$store.state.user.userData.permissions?.includes('firma_paylasimi.email_ekleyebilir_duzenleyebilir');
    },
  },
  methods: {
    refetchData() {
      // Links.vue içindeki refetchData'yı trigger et
      this.$refs.campaignList?.refetchData?.();
    },
  },
};
</script>
